/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRolePermissionRelationDto
 */
export interface UpdateRolePermissionRelationDto {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRolePermissionRelationDto
     */
    relation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateRolePermissionRelationDto
     */
    roleId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRolePermissionRelationDto
     */
    permission?: string | null;
}

export function UpdateRolePermissionRelationDtoFromJSON(json: any): UpdateRolePermissionRelationDto {
    return UpdateRolePermissionRelationDtoFromJSONTyped(json, false);
}

export function UpdateRolePermissionRelationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRolePermissionRelationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'relation': !exists(json, 'relation') ? undefined : json['relation'],
        'roleId': json['roleId'],
        'permission': !exists(json, 'permission') ? undefined : json['permission'],
    };
}

export function UpdateRolePermissionRelationDtoToJSON(value?: UpdateRolePermissionRelationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'relation': value.relation,
        'roleId': value.roleId,
        'permission': value.permission,
    };
}


